import styled from "styled-components";

export const $WebsiteWrapper = styled.div`
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
`;
